import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as actions from '../../actions/google-address-verify';

export class GoogleAddressItem extends Component {
    render(){
        const { addressPredictions = [], setActivePrediction, selectPrediction, place } = this.props;
        return ( place ?
            <div className={'google-address-item' + (place.active ? ' active' : '')}
                 onMouseOver={() => setActivePrediction(place.index)}
                 onMouseDown={() => selectPrediction(addressPredictions[place.index])}
                 onTouchStart={() => setActivePrediction(place.index)}
                 onTouchEnd={() => selectPrediction(addressPredictions[place.index])}>
                <i className="fa fa-map-marker"></i>
                <span className="main-text">{place.formattedSuggestion.mainText}</span>
                <span className="secondary-text">{place.formattedSuggestion.secondaryText}</span>
            </div>
                : null
        );
    }
}

GoogleAddressItem.propTypes = {
    setActivePrediction: PropTypes.func,
    selectPrediction: PropTypes.func,
    place: PropTypes.shape({
        suggestion: PropTypes.string,
        placeId: PropTypes.string,
        active: PropTypes.bool,
        index: PropTypes.number,
        formattedSuggestion: PropTypes.object
    })
};

const mapDispatchToProps = (dispatch) => {
    return {
        setActivePrediction: (index) => dispatch(actions.setActivePrediction(index)),
        selectPrediction: (prediction) => dispatch(actions.selectPrediction(prediction))
    }
};

export default connect(null, mapDispatchToProps)(GoogleAddressItem);
